module.exports = __webpack_public_path__ + "static/media/rehire.4dc28b02.svg";